"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRiskLocations = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const address_entity_1 = require("./address.entity");
let OpportunityRiskLocations = class OpportunityRiskLocations {
    constructor(id, opportunityId, addressId) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.addressId = addressId;
    }
};
exports.OpportunityRiskLocations = OpportunityRiskLocations;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRiskLocations.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRiskLocations.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRiskLocations.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.opportunityRiskLocations, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRiskLocations.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.opportunityRiskLocations, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRiskLocations.prototype, "address", void 0);
exports.OpportunityRiskLocations = OpportunityRiskLocations = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_risk_location_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], OpportunityRiskLocations);
